import * as Types from '../actions/Types'
import * as Constants from '../helpers/Constants'

const INITIAL_STATE = {
  alert: {
    show: false,
    header: '',
    text: '',
    type: Constants.ONE_BUTTON,
    firstButton: { title: '', onPress: () => {} },
    secondButton: { title: '', onPress: () => {} },
    thirdButton: { title: '', onPress: () => {} }
  },
  language: 'SE',
  menuOpen: true,
  showEditEmailModal: false,
  showEditPasswordModal: false
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action

  switch (type) {
    case Types.TOGGLE_MENU:
      return {
        ...state,
        menuOpen: !state.menuOpen
      }
    case Types.SHOW_ALERT:
      return {
        ...state,
        alert: {
          show: true,
          header: payload.header,
          text: payload.text,
          type: payload.type,
          firstButton: payload.firstButton,
          secondButton: payload.secondButton,
          thirdButton: payload.thirdButton
        }
      }
    case Types.HIDE_ALERT:
      return {
        ...state,
        alert: {
          ...state.alert,
          show: false
        }
      }
    case Types.SET_LANGUAGE:
      return { ...state, language: payload }
    case Types.SET_SNACK_BAR:
      return { ...state, snackBar: payload }
    case Types.SHOW_EDIT_EMAIL_MODAL:
      return { ...state, showEditEmailModal: true }
    case Types.HIDE_EDIT_EMAIL_MODAL:
      return { ...state, showEditEmailModal: false }
    case Types.SHOW_EDIT_PASSWORD_MODAL:
      return { ...state, showEditPasswordModal: true }
    case Types.HIDE_EDIT_PASSWORD_MODAL:
      return { ...state, showEditPasswordModal: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Config.js